export const QUESTION_TYPE_MULTI_CHOICE = 'multi_choice';
export const QUESTION_TYPE_MULTI_CHOICE_MULTI_SELECT = 'multi_choice_multi_select';
export const QUESTION_TYPE_ESSAY = 'essay';
export const QUESTION_TYPE_ORDERING = 'ordering';
export const QUESTION_TYPE_CATEGORISATION = 'categorisation';
export const QUESTION_TYPE_FILL_BLANK = 'fill_blank';
export const QUESTION_TYPE_LABELLING = 'labelling';

// Drag-and-drop question types. They store their answer data in the JSON
// `options` columns (question + choice) rather than dedicated tables.
export const DND_QUESTION_TYPES = [
  QUESTION_TYPE_ORDERING,
  QUESTION_TYPE_CATEGORISATION,
  QUESTION_TYPE_FILL_BLANK,
  QUESTION_TYPE_LABELLING,
];
